import { call, put, takeEvery, all, fork } from 'redux-saga/effects';
import {
  GET_PRE_PROPOSAL,
  GET_PRE_PROPOSAL_BY_HASH,
  UPDATE_PRE_PROPOSAL,
  PENDING_PRE_PROPOSAL,
  APPROVE_PRE_PROPOSAL,
} from './actionType';

import {
  PreProposalApiResponseError,
  PreProposalApiResponseSuccess,
} from './action';

import {
  getPreProposal,
  getPreProposalByHash,
  updatePreProposal,
  pendingPreProposal,
  approvePreProposal,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* requestGetPreProposal({ payload }) {
  try {
    const response = yield call(getPreProposal, payload);
    yield put(PreProposalApiResponseSuccess(GET_PRE_PROPOSAL, response));
  } catch (error) {
    yield put(PreProposalApiResponseError(GET_PRE_PROPOSAL, error));
  }
}

function* requestGetPreProposalByHash({ payload }) {
  try {
    const response = yield call(getPreProposalByHash, payload.hash);
    yield put(
      PreProposalApiResponseSuccess(GET_PRE_PROPOSAL_BY_HASH, response)
    );
  } catch (error) {
    yield put(PreProposalApiResponseError(GET_PRE_PROPOSAL_BY_HASH, error));
  }
}

function* requestUpdatePreProposal({ payload }) {
  try {
    const response = yield call(updatePreProposal, {
      hash: payload.hash,
      data: payload.data,
    });
    yield put(PreProposalApiResponseSuccess(UPDATE_PRE_PROPOSAL, response));
    notifySuccess('Pré-proposta atualizada com sucesso!');
  } catch (error) {
    yield put(PreProposalApiResponseError(UPDATE_PRE_PROPOSAL, error));
    notifyError('Erro ao atualizar pré-proposta');
  }
}

function* requestPendingPreProposal({ payload }) {
  try {
    const response = yield call(pendingPreProposal, {
      hash: payload.hash,
      data: payload.data,
    });
    yield put(PreProposalApiResponseSuccess(PENDING_PRE_PROPOSAL, response));
    notifySuccess('Pré-proposta marcada como pendente com sucesso!');
  } catch (error) {
    yield put(PreProposalApiResponseError(PENDING_PRE_PROPOSAL, error));
    notifyError('Erro ao marcar pré-proposta como pendente');
  }
}

function* requestApprovePreProposal({ payload }) {
  const { hash, history } = payload;

  try {
    const response = yield call(approvePreProposal, hash);
    yield put(PreProposalApiResponseSuccess(APPROVE_PRE_PROPOSAL, response));
    notifySuccess('Pré-proposta aprovada com sucesso!');
    history.push(`/propostas/view/${response.proposalHashId}`);
  } catch (error) {
    yield put(PreProposalApiResponseError(APPROVE_PRE_PROPOSAL, error));
    notifyError('Erro ao aprovar pré-proposta');
  }
}

export function* watchGetPreProposal() {
  yield takeEvery(GET_PRE_PROPOSAL, requestGetPreProposal);
}

export function* watchrequestGetPreProposalByHash() {
  yield takeEvery(GET_PRE_PROPOSAL_BY_HASH, requestGetPreProposalByHash);
}

export function* watchUpdatePreProposal() {
  yield takeEvery(UPDATE_PRE_PROPOSAL, requestUpdatePreProposal);
}

export function* watchPendingPreProposal() {
  yield takeEvery(PENDING_PRE_PROPOSAL, requestPendingPreProposal);
}

export function* watchApprovePreProposal() {
  yield takeEvery(APPROVE_PRE_PROPOSAL, requestApprovePreProposal);
}

function* PreProposalSaga() {
  yield all([fork(watchGetPreProposal)]);
  yield all([fork(watchrequestGetPreProposalByHash)]);
  yield all([fork(watchUpdatePreProposal)]);
  yield all([fork(watchPendingPreProposal)]);
  yield all([fork(watchApprovePreProposal)]);
}

export default PreProposalSaga;
